import { DealStatus } from 'components/common/types/Deal.types';

export const warningDealStatuses = [DealStatus.APPROVED, DealStatus.LIVE].map((status) => status.valueOf());
